var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Samples"},[_c('Header'),_c('div',{staticClass:"PageContentWrap"},[_c('div',{staticClass:"InnerWrap"},[_c('AnalysesUploadSection'),_c('AnalysesStatus'),_c('ExternalAnalysesStatus'),_c('StandardSamplesTable')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }